<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Archived Maintenance Tasks'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [hasBottomNav]="true" [isPrimaryLayer]="true">


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (windowService?.isDesktopRes) {
      <tidy-desktop-header [isLoading]="!loaded">
        <div class="wrappable-container">
          <ion-img
            [src]="'assets/svg/arrow-back-black.svg'"
            class="desktop-back-icon"
            (click)="goBack()" />
          <tidy-text
            [title]="'Archived Maintenance Tasks'" />
          <div class="desktop-nav-search">
            <form [formGroup]="form" novalidate action="#">
              <tidy-search-input
                class="header-search"
                formControlName="search"
                [placeholder]="'Search'" />
            </form>
          </div>
        </div>
      </tidy-desktop-header>
    }

    @if (loaded) {
        @if (!archivedTasks?.length) {
          <tidy-alert>
            <tidy-row>
              <tidy-text
                [body]="'No Maintenance Tasks'" />
            </tidy-row>
          </tidy-alert>
        }
        @for (task of archivedTasks; track task) {
          <tidy-card (click)="goToTask(task)" style="cursor: pointer">
            <tidy-row [alignLastItemRight]="true">
              <tidy-text
                [ngStyle]="task?.checkedUsers?.length <= 1 ? {'max-width': '50ch'} : {'max-width': '20ch'}"
                [header]="task?.title | translate" />
              <div class="task-assign-user">
                @if (getUserIcon(task?.checkedUsers) === 'user') {
                  <div class="initials" [style.background]="util.getAvatarGradient(task?.checkedUsers[0]?.name || 'BA')">
                    {{task?.checkedUsers[0]?.name | slice:0:1 | uppercase}}
                  </div>
                }
                @if (getUserIcon(task?.checkedUsers) === 'concierge') {
                  <tidy-image
                    [src]="'assets/img/concierge.svg'"
                    class="title-size" />
                }
                @if (task?.checkedUsers?.length > 1) {
                  <tidy-text
                    style="margin-left: -5px"
                    [body]="'+' + task?.checkedUsers?.length - 1" />
                }
              </div>
            </tidy-row>
            <tidy-row [alignLastItemRight]="true">
              <tidy-image
                [src]="getIssueHeaderIcon(task)"
                class="urgency-icon" />
              <tidy-text
                [body]="getAddressName(task)" />
              <div>
                @if (task?.jobs?.length) {
                  <ion-chip style="margin-right: 0;">
                    <tidy-image
                      [src]="categories[0].icon_url"
                      style="height: 25px" />
                    <tidy-image
                      [src]="'assets/img/task-job-canceled.svg'"
                      style="height: 25px" />
                  </ion-chip>
                }
                @if (task?.jobs?.length > 1) {
                  <tidy-text
                    style="margin-left: 30px"
                    [body]="'+' + task?.jobs?.length - 1" />
                }
              </div>
            </tidy-row>
          </tidy-card>
        }
    }

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" />
